import {Enumeration} from 'Users/api';
import {LineOfBusinessValue} from './LineOfBusiness';

export enum Application {
  Portal = 1,
  Agent,
  EnrollTrack,
  Beneficiary,
  BOSTools,
  Messaging,
  AppEntry,
}

export type ApplicationEnum = Enumeration;

export const mapLineOfBusinessToApplication = (lineOfBusinessValue: LineOfBusinessValue) => {
  switch (lineOfBusinessValue) {
    case 'agent':
      return Application.Agent;
    case 'enrolltrack':
      return Application.EnrollTrack;
    case 'bostools':
      return Application.BOSTools;
    case 'beneficiary':
      return Application.Beneficiary;
    case 'messaging':
      return Application.Messaging;
    case 'appentry':
      return Application.AppEntry;
  }
};
